import React from "react";

function SimpleDropdown({
  label,
  containerClass,
  dropdownClass,
  dropdownName,
  options,
  onChange,
  value,
}) {
  return (
    <div className={containerClass}>
      <h5>{label}</h5>
      <select className={dropdownClass} name={dropdownName} onChange={onChange}>
        {options.map((opt, i) => {
          return (
            <option key={i} value={opt}>
              {opt}
            </option>
          );
        })}
      </select>
    </div>
  );
}

export default SimpleDropdown;
